import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { PlusIcon, BookOpenIcon } from 'lucide-react';
export function Trainings() {
  return <div className="space-y-6" data-id="element-3671">
      <div className="flex justify-between items-center" data-id="element-3672">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-3673">Trainings</h1>
        <Button variant="primary" size="sm" data-id="element-3674">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-3675" />
          Add Training
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3676">
        <div className="col-span-1 md:col-span-1" data-id="element-3677">
          <Card title="Training Categories" data-id="element-3678">
            <div className="h-64 flex flex-col items-center justify-center border border-dashed border-gray-300 rounded-md" data-id="element-3679">
              <BookOpenIcon className="h-8 w-8 text-gray-400" data-id="element-3680" />
              <p className="mt-2 text-gray-500 text-sm" data-id="element-3681">No categories yet</p>
              <Button variant="outline" size="sm" className="mt-2" data-id="element-3682">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-3683" />
                Add Category
              </Button>
            </div>
          </Card>
        </div>
        <div className="col-span-1 md:col-span-2" data-id="element-3684">
          <Card title="Training Programs" actions={<Button variant="ghost" size="sm" data-id="element-3686">
                Filter
              </Button>} data-id="element-3685">
            <div className="h-64 flex flex-col items-center justify-center border border-dashed border-gray-300 rounded-md" data-id="element-3687">
              <p className="text-gray-500" data-id="element-3688">No training programs found</p>
              <Button variant="outline" size="sm" className="mt-2" data-id="element-3689">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-3690" />
                Create Program
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}